// Export utilities for TTP Play Day

export const exportToCSV = (data, filename, headers) => {
  if (!data || data.length === 0) {
    alert("No data to export");
    return;
  }

  const csvRows = [];
  
  // Add headers
  csvRows.push(headers.join(","));
  
  // Add data rows
  data.forEach(row => {
    const values = headers.map(header => {
      const val = row[header] ?? "";
      // Escape quotes and wrap in quotes if contains comma
      const escaped = String(val).replace(/"/g, '""');
      return escaped.includes(",") || escaped.includes('"') || escaped.includes("\n") 
        ? `"${escaped}"` 
        : escaped;
    });
    csvRows.push(values.join(","));
  });

  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const handlePrint = (title, subtitle) => {
  // Add print header dynamically
  const printHeader = document.createElement("div");
  printHeader.className = "print-header print-only";
  printHeader.style.display = "none";
  printHeader.innerHTML = `
    <h1>TTP Play Day</h1>
    <h2>${title}</h2>
    ${subtitle ? `<p>${subtitle}</p>` : ""}
  `;
  
  const mainContent = document.querySelector("main");
  if (mainContent) {
    mainContent.insertBefore(printHeader, mainContent.firstChild);
  }
  
  window.print();
  
  // Remove print header after printing
  setTimeout(() => {
    printHeader.remove();
  }, 100);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", { 
    year: "numeric", 
    month: "long", 
    day: "numeric" 
  });
};
